<template>
  <div>
    <v-container
      tag="section"
    >
      <v-row>
        <v-col
          v-for="(card, index) in arrayComDataModificada"
          :key="index"
          cols="12"
          class="pa-0"
        >
          <v-flex
            v-if="card.created_at"
            tag="div"
            class="subtitle-1 grey--text text--darken-1 pt-0"
            data-cy="data_compra"
          >
            Compra(s) em {{ card.created_at }}
          </v-flex>
          <v-card
            class="pl-4 pr-2 mt-1 mb-3 mb-6"
            min-height="160"
            :style="`border-left: 5px solid var(--v-${corStatus(card)}-base)`"
            @click="abrirModal(index)"
          >
            <v-card-text class="subtitle-2 pa-0 pt-4" data-cy="card_compra">
              <div
                class="d-flex flex-no-wrap justify-space-between align-center"
                :class="{ 'mb-2': !card.total_order_bump_items }"
              >
                <v-card-title
                  class="body-2 primary--text font-weight-bold pa-0 text-truncate d-block"
                >
                  <div
                    v-if="statusCard(card) === 'Inadimplente'"
                    class="d-flex align-start mb-2"
                  >
                    <v-btn
                      color="success"
                      class="font-weight-bold"
                      small
                      :loading="loadingPagarReativar[card.id]"
                      :disabled="loadingPagarReativar[card.id]"
                      @click.stop="pagarEReativar(card)"
                    >
                      Pagar e Reativar
                    </v-btn>
                  </div>

                  <span class="ellipsis nome-produto">{{ card.product_name }}</span>
                  -
                  <span class="ellipsis nome-plano">{{ card.plan_name }}</span>
                </v-card-title>
                <v-chip
                  v-if="card.total_order_bump_items"
                  outlined
                  label
                  class="primary--text ml-5 flex-shrink-0"
                  data-cy="card_order_bump"
                >
                  {{ card.total_order_bump_items | getTextItemOrderBump }}
                </v-chip>
              </div>
              <p
                class="mb-1 pl-0 d-flex align-center"
                data-cy="valor_compra"
              >
                <span v-if="card.is_instalment_recovery && card.freight_cost">
                  <IconePagamento :dados="card" />
                  Primeira parcela: <strong>{{
                    valorParcelaRecuperacao(card) | moeda(card.currency_symbol)
                  }}</strong>
                  + <strong>{{
                    card.freight_cost | moeda(card.currency_symbol)
                  }}</strong> (frete)<br>

                  <IconePagamento :dados="card" />
                  Parcelas seguintes: <strong>{{ card.max_recurrence_instalments - 1 }}x</strong>
                  de <strong>{{
                    valorParcelaRecuperacao(card) | moeda(card.currency_symbol)
                  }}</strong>
                </span>

                <span v-else-if="card.order_bump_assinatura_show_message">
                  <IconePagamento :dados="card" />
                  -
                </span>

                <span v-else>
                  <IconePagamento :dados="card" />

                  {{ card.total | moeda(card.currency_symbol) }}

                  <span
                    v-if="card.is_instalment_recovery"
                    class="pl-1 grey--text"
                  >
                    ({{ card.paid_recurrence_instalments }}
                    de {{ card.max_recurrence_instalments }} parcelas)
                  </span>
                </span>
              </p>
              <p
                class="mb-1 pt-1"
                data-cy="status_compra"
                :class="corStatus(card, true)"
              >
                <v-icon
                  :color="corStatus(card)"
                >
                  {{ iconeStatus(card) }}
                </v-icon>
                {{ statusCard(card) }}
              </p>
              <p class="caption mb-0">
                Vendedor
              </p>
              <p
                class="font-weight-bold mt-n1"
                data-cy="vendedor_compra"
                :class="card.is_instalment_recovery ? 'mb-0' : ''"
              >
                {{ card.seller_name }}
              </p>
              <v-chip
                v-if="card.is_instalment_recovery"
                class="mt-2 font-weight-bold mb-4"
                color="primary"
                small
              >
                Compra parcelada
              </v-chip>
            </v-card-text>
            <v-btn
              absolute
              depressed
              fab
              bottom
              right
              small
              color="primary"
              :data-cy="`btn_mais_card`"
            >
              <v-icon
                color="white"
                small
              >
                fas fa-plus
              </v-icon>
              <v-badge
                v-if="notificacaoReembolso(card)"
                avatar
                bordered
                color="red"
                offset-x="10"
                offset-y="-10"
                data-cy="icone_notificacao_reembolso"
              >
                <template v-slot:badge>
                  <v-avatar>
                    <v-icon x-small>
                      mdi-bell
                    </v-icon>
                  </v-avatar>
                </template>
              </v-badge>
            </v-btn>
          </v-card>
        </v-col>
      </v-row>

      <ModalFullScreen
        v-if="compraSelecionada"
        :dialog="!!compraSelecionada"
        :compra-id="compraSelecionada"
        :notificacao-mensagem="notificacaoMensagem()"
        @changeDialog="atualizarDados"
      />
      <GerenciarAssinaturas
        v-if="gerenciarAssinaturaModal"
        :compra-id="gerenciarAssinaturaModal"
        :dialog="!!gerenciarAssinaturaModal"
        @changeDialog="atualizarDados"
      />
      <NaoEncontrei
        v-if="aindaPrecisoAjudaModal"
        :dialog="!!aindaPrecisoAjudaModal"
      />
      <ModalPagamentoRecusado
        v-if="showModalPagamentoRecusado"
        v-model="showModalPagamentoRecusado"
        :motivo="motivoErro"
        :compra-id="compraIdErro"
        :permite-pix="permitePixErro"
        @pagar-pix="pagarPixDaRecusa"
      />
      <ModalPagamentoPix
        v-if="showModalPix"
        v-model="showModalPix"
        :qr-code="dadosPagamentoPix.qrCode"
        :codigo-pix="dadosPagamentoPix.codigoPix"
        :compra-id="dadosPagamentoPix.compraId"
        @dataUpdated="handlePixPaymentConfirmed"
      />
      <SnackBar
        :mensage="snackBar.message"
        :snackbar="snackBar.show"
        :color="snackBar.color"
        :timeout="snackBar.timeout"
        @changeSnackBar="value => snackBar.show = value.visible"
      />
    </v-container>
  </div>
</template>

<script>

import api from '@/api';
import GerenciarAssinaturas from '@/components/Compras/GerenciarAssinaturas.vue';
import ModalFullScreen from '@/components/Compras/ModalFullScreen.vue';
import NaoEncontrei from '@/components/Compras/NaoEncontrei.vue';
import IconePagamento from '@/components/Compras/IconePagamento.vue';
import ModalPagamentoRecusado from '@/components/Compras/ModalPagamentoRecusado.vue';
import ModalPagamentoPix from '@/components/Compras/ModalPagamentoPix.vue';
import SnackBar from '@/components/SnackBar.vue';

export default {
  name: 'Card',

  components: {
    GerenciarAssinaturas,
    ModalFullScreen,
    NaoEncontrei,
    IconePagamento,
    ModalPagamentoRecusado,
    ModalPagamentoPix,
    SnackBar,
  },

  props: {
    dados: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      dataAnterior: '',
      dadosDaCompra: {},
      dadosLocal: [],
      indiceModalAberto: null,
      showModalPagamentoRecusado: false,
      motivoErro: '',
      compraIdErro: null,
      permitePixErro: false,
      showModalPix: false,
      loadingPagarReativar: {},
      dadosPagamentoPix: {
        qrCode: '',
        codigoPix: '',
        compraId: null,
      },
      snackBar: {
        message: '',
        color: 'success',
        timeout: 6000,
        show: false,
      },
    };
  },

  computed: {
    arrayComDataModificada() {
      return this.dadosLocal.map(item => ({
        ...item,
        created_at: this.tratamentoDaData(item.created_at),
      }));
    },

    aindaPrecisoAjudaModal() {
      if (this.$route && this.$route.name === 'nao-encontrei-o-que-preciso-modal') return true;

      return null;
    },

    compraSelecionada() {
      if (this.$route && this.$route.name === 'detalhe-compra') {
        const { compraId } = this.$route.params;
        if (!compraId) return null;

        return parseInt(compraId, 10);
      }
      return null;
    },

    gerenciarAssinaturaModal() {
      if (this.$route && this.$route.name === 'gerenciar-assinatura') {
        const { compraId } = this.$route.params;
        if (!compraId) return null;

        return parseInt(compraId, 10);
      }
      return null;
    },
  },

  watch: {
    '$route.fullPath': {
      handler() {
        this.$forceUpdate();
      },
    },
    dados() {
      this.dadosLocal = this.dados;
      this.verificarRecobrancaPendente();
    },
  },

  created() {
    this.dadosLocal = this.dados;
    this.verificarRecobrancaPendente();
  },

  methods: {
    async scoreConsumidor(orderId) {
      await api.post('/consumer_score', {
        action: 'details_order',
        orderId,
      });
    },

    abrirModal(key) {
      this.indiceModalAberto = key;
      this.dadosDaCompra = this.arrayComDataModificada[key];
      this.scoreConsumidor(this.dadosDaCompra.id);
      this.$router.push({ name: 'detalhe-compra', params: { compraId: this.dadosDaCompra.id } });
    },

    tratamentoDaData(date) {
      const data = new Date(date.replace(' ', 'T'));
      const dataAtual = `${data.getDate()}${data.getMonth()}${data.getFullYear()}`;
      const configuracoes = { year: 'numeric', month: 'long', day: 'numeric' };

      if (dataAtual !== this.dataAnterior) {
        this.dataAnterior = dataAtual;
        return data.toLocaleDateString('pt-BR', configuracoes);
      }

      return '';
    },

    notificacaoMensagem() {
      const dadosCompra = this.dados.find(({ id }) => (id === this.compraSelecionada));
      if (dadosCompra && dadosCompra.notificacao_mensagem) return dadosCompra.notificacao_mensagem;
      return false;
    },

    statusCard(card) {
      const statusReembolso = !!card.refund_request_status_slug;
      const statusCancelado = card.refund_request_status_slug === 'reembolso-cancelado';

      if (statusReembolso && !statusCancelado) return card.refund_request_status;
      if (card.membership_status_flag
        && !card.is_instalment_recovery) return card.membership_status;

      return card.status;
    },

    corStatus(card, possuiTexto = false) {
      const texto = possuiTexto ? '--text' : '';
      const flagReembolso = card.refund_request_status_flag;
      const statusReembolso = card.refund_request_status_slug === 'reembolso-cancelado';

      if (flagReembolso && !statusReembolso) return card.refund_request_status_flag + texto;
      if (card.membership_status_flag
        && !card.is_instalment_recovery) return card.membership_status_flag + texto;

      return card.status_flag + texto;
    },

    iconeStatus(card) {
      const flagReembolso = card.refund_request_status_flag;
      const statusReembolso = card.refund_request_status_slug === 'reembolso-cancelado';

      if (flagReembolso && !statusReembolso) {
        return this.retornaIcone(card.refund_request_status_flag);
      }
      if (card.membership_status_flag && !card.is_instalment_recovery) {
        return this.retornaIcone(card.membership_status_flag);
      }

      return this.retornaIcone(card.status_flag);
    },

    retornaIcone(status) {
      if (status === 'warning') return 'error';
      if (status === 'success') return 'check_circle';
      return 'cancel';
    },

    notificacaoReembolso(card) {
      const statusReembolso = [
        'aguardando-estorno',
        'aguardando-dados-consumidor',
        'aguardando-devolucao-produto',
        'aguardando-resposta-consumidor',
      ];
      const refund = card.refund_request_status_slug;
      return statusReembolso.includes(refund);
    },

    atualizarDados(dadosDialog) {
      let indice = this.indiceModalAberto;
      if (indice === null) {
        indice = this.arrayComDataModificada.findIndex(compra => compra.id === dadosDialog.data.id);
      }
      if (indice >= 0) {
        const status = dadosDialog.data.refund_request_status;
        const slug = dadosDialog.data.refund_request_status_slug;
        this.dadosLocal[indice].refund_request_status = status;
        this.dadosLocal[indice].refund_request_status_slug = slug;
      }
      this.$router.push('/minhas-compras');
    },

    valorParcelaRecuperacao(card) {
      return card.paid_recurrence_instalments > 1
        ? card.total
        : card.total - card.freight_cost;
    },

    extractErrorMessage(error) {
      const data = error.response && error.response.data;
      if (data) {
        if (data.refusalMessageMon) return data.refusalMessageMon;
        if (data.message) {
          try {
            const parsedMessage = JSON.parse(data.message);
            if (parsedMessage.error) return parsedMessage.error;
          } catch (parseError) {
            return data.message;
          }
        }
      }
      return error.message || 'Erro desconhecido';
    },

    setSnackbar(mensagem, status = 'success', timeout = 6000) {
      this.snackBar.message = mensagem;
      this.snackBar.color = status;
      this.snackBar.timeout = timeout;
      this.snackBar.show = true;
    },

    marcarComoAtiva(compraId) {
      const cardIndex = this.dadosLocal.findIndex(item => item.id === compraId);
      if (cardIndex >= 0) {
        this.$set(this.dadosLocal[cardIndex], 'membership_status', 'Ativa');
        this.$set(this.dadosLocal[cardIndex], 'membership_status_flag', 'success');
      }
    },

    abrirModalRecusa(card, error) {
      this.motivoErro = this.extractErrorMessage(error);
      this.compraIdErro = card.id;
      this.permitePixErro = card.membership_allows_pix === true;
      this.showModalPagamentoRecusado = true;
    },

    produtoIdRecobranca(card) {
      return card && card.products && card.products[0] ? card.products[0].id : null;
    },

    async gerarPixRecobranca(card) {
      const dadosProduto = this.produtoIdRecobranca(card);
      if (!dadosProduto) {
        throw new Error('Não foi possível identificar o produto da assinatura.');
      }

      const response = await api.post('/recovery-payment-pix', { dadosProduto });

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao gerar pagamento PIX');
      }

      this.dadosPagamentoPix = {
        qrCode: response.data.data.qrCodePix,
        codigoPix: response.data.data.codigo,
        compraId: card.id,
      };
      this.showModalPix = true;
    },

    async recobrarCredito(card) {
      const dadosProduto = this.produtoIdRecobranca(card);
      if (!dadosProduto) {
        throw new Error('Não foi possível identificar o produto da assinatura.');
      }

      const response = await api.post('/recovery-payment-credit', { dadosProduto });

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao processar pagamento');
      }

      this.marcarComoAtiva(card.id);
      this.setSnackbar('Pagamento aprovado! Sua assinatura foi reativada.', 'success');
    },

    async pagarEReativar(card) {
      this.$set(this.loadingPagarReativar, card.id, true);

      try {
        if (card.is_credit_card === false) {
          await this.gerarPixRecobranca(card);
        } else {
          await this.recobrarCredito(card);
        }
      } catch (error) {
        this.abrirModalRecusa(card, error);
      } finally {
        this.$set(this.loadingPagarReativar, card.id, false);
      }
    },

    async pagarPixDaRecusa(compraId) {
      this.showModalPagamentoRecusado = false;
      const card = this.dadosLocal.find(item => item.id === compraId);
      if (!card) return;

      this.$set(this.loadingPagarReativar, card.id, true);
      try {
        await this.gerarPixRecobranca(card);
      } catch (error) {
        this.abrirModalRecusa(card, error);
      } finally {
        this.$set(this.loadingPagarReativar, card.id, false);
      }
    },

    async alterarFormaParaCartao(card) {
      await api.put(`/membership/payment-method/${card.id}`, {
        payment_method: 'credit_card',
      });
    },

    async recobrarComNovoCartao(card) {
      this.$set(this.loadingPagarReativar, card.id, true);
      try {
        if (card.is_credit_card === false) {
          // Assinatura em PIX/boleto: troca a forma para cartão (boleto -> 0) antes de cobrar.
          // A recobrança sozinha só reativa e quita a fatura; não altera a forma da assinatura.
          await this.alterarFormaParaCartao(card);
        }
        await this.recobrarCredito(card);
      } catch (error) {
        this.abrirModalRecusa(card, error);
      } finally {
        this.$set(this.loadingPagarReativar, card.id, false);
      }
    },

    verificarRecobrancaPendente() {
      const compraId = this.$store.state.meuperfil.assinaturaRecobrar;
      if (!compraId) return;

      const card = this.dadosLocal.find(item => item.id === compraId);
      if (!card) return;

      this.$store.dispatch('meuperfil/setAssinaturaRecobrar', null);
      this.recobrarComNovoCartao(card);
    },

    handlePixPaymentConfirmed() {
      this.marcarComoAtiva(this.dadosPagamentoPix.compraId);
      this.setSnackbar('Pagamento confirmado! Sua assinatura foi reativada.', 'success');
    },
  },
};
</script>

<style lang="scss" scoped>

.nome-produto {
  max-width: 50%;
}

.nome-plano {
  max-width: 50%;
}

</style>
